import type { AuthMeResponse } from "@/types/api";

import { apiClient } from "./client";

export interface AuthStatus {
  auth_enabled: boolean;
  authenticated: boolean;
}

export interface LoginResponse {
  access_token: string;
}

export const authApi = {
  getMe: async (): Promise<AuthMeResponse> => {
    return apiClient.get<AuthMeResponse>("/api/auth/me");
  },

  getStatus: async (): Promise<AuthStatus> => {
    // Проверяем наличие токена в localStorage
    const token = localStorage.getItem("jwt_token");
    // Если токен есть, считаем что пользователь авторизован
    // Авторизация всегда включена если используется JWT
    return {
      auth_enabled: true,
      authenticated: !!token,
    };
  },

  login: async (username: string, password: string): Promise<void> => {
    await apiClient.login(username, password, undefined, { redirect: false });
  },

  logout: async (): Promise<void> => {
    // Очищаем JWT токен
    localStorage.removeItem("jwt_token");
  },
};
